import { Post } from '../http/httpVerbs';

export const apiCreatorRegister = async (userData) => {
    try {
        const response = await Post(`${process.env.REACT_APP_API_URL}/auth/creator/register`, userData);
        return response;
    } catch (error) {
        throw error;
    }
};
